import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router, RouterLink } from '@angular/router';
import { en_US, it_IT, NzI18nService } from 'ng-zorro-antd/i18n';
import { StorageService } from '../../services/storage.service';
import { AccountDataDTO, UserAccountDTO, UserRegisterDataDTO, UsersAccountDTO } from '../../classes/user-account.dto';
import { NzModalModule, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NotificationsComponent } from '../notifications/notifications/notifications.component';
import { ModalWithTwoButtonsComponent } from '../modals/modal-with-two-buttons/modal-with-two-buttons.component';
import { AuthService } from '../../services/auth.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { HttpService } from '../../services/http.service';
import { DataService } from '../../services/data.service';
import { AppointmentStepperService } from '../../services/appointment-stepper.service';
import { AppComponent } from '../../app.component';
import { GtmService } from '../../services/gtm.service';
import { KeycloakService } from 'keycloak-angular';
import { ConfigService } from '../../services/env-config.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, NzLayoutModule, NzMenuModule, NzModalModule, NzDropDownModule, NzIconModule, NzButtonModule, NzBadgeModule, NzDividerModule, TranslateModule, RouterLink],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NavbarComponent implements OnInit, OnDestroy {
  selectedLang: string = 'it';
  userData: UserRegisterDataDTO = JSON.parse(<string>this.storageService.getItem('userData'));
  secondUser!: any;
  isLoggedIn: boolean = false;
  subscription: Array<Subscription> = [];
  notificationCount!: number;
  pageSize: any;
  pageIndex: any;
  logo: any;
  isUserManagementAble: boolean = true;
  users: any;
  private destroy$ = new Subject<void>();
  hasActivationCode?: boolean;
  currentUrl!: string;
  userDataToBeUpdated!: UserAccountDTO;
  functions: string[] = [];
  maintenanceMode!: boolean;


  constructor(
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef,
    private i18n: NzI18nService,
    private storageService: StorageService,
    private modal: NzModalService,
    private router: Router,
    private authService: AuthService,
    private http: HttpService,
    private dataService: DataService,
    private appointmentStepperService: AppointmentStepperService,
    private gtmService: GtmService,
    private keycloakService: KeycloakService,
    private configService: ConfigService
  ) {
    this.router.events.subscribe(() => {
          this.currentUrl = this.router.url;
    })
  }

  ngOnInit(): void {
    const userData = JSON.parse(localStorage.getItem('userData')!);
    this.functions = userData?.functions || [];
    this.subscription.push(
      this.authService.isAuthenticatedObservable().subscribe((logged: boolean) => {
        this.isLoggedIn = logged;
        if (this.isLoggedIn) {
          this.userData = JSON.parse(<string>this.storageService.getItem('userData'));
          this.isUserManagementAble = this.userData.functions ? this.userData.functions.includes('MPM') : false;
          this.updateNotificationCount();
          this.getRelatedProfiles();
          this.dataService.getAccountDataFrom().subscribe((res) => {
            if (res) {
              this.dataService.getAccountData().subscribe((res) => {
                if (res) {
                  this.secondUser = res;
                } else {
                  const oldUserData = JSON.parse(<string>this.storageService.getItem('oldUserData'));
                  this.secondUser = !!oldUserData ? { customer: JSON.parse(<string>this.storageService.getItem('userData')) } : null;
                }
              });
            } else {
              const oldUserData = JSON.parse(<string>this.storageService.getItem('oldUserData'));
              this.secondUser = !!oldUserData ? { customer: JSON.parse(<string>this.storageService.getItem('userData')) } : null;
            }
          });
          this.dataService.getChangeNavbar().subscribe((res) => {
            if (res) {
              this.getRelatedProfiles();
            }
          });
          AppComponent.onNotification.subscribe(() => {
               this.updateNotificationCount();
          });
        }
      })
    );
    this.dataService.config$.subscribe((config) => {
      if (config) {
        this.logo = config.logos?.header;
      }
    });
    this.dataService.activationCode$.subscribe((activationCode) => {
      this.hasActivationCode = activationCode;
    });
    this.configService.getConfig().subscribe((res: any) =>{
      this.maintenanceMode = res?.maintenanceMode;
    });
  }

  onLogoClick(){
     this.userDataToBeUpdated = JSON.parse(this.storageService.getItem('userDataToBeUpdated')!) as UserAccountDTO;
     if(this.userDataToBeUpdated){
      this.authService.logout();
      this.storageService.removeItem('userDataToBeUpdated');
      this.storageService.removeItem('updateProfileFrom');
      this.router.navigate(['/login']);
     } else if(!this.userDataToBeUpdated && this.isLoggedIn) {
      this.router.navigate(['/medical-consultations']);
     } else if(!this.userDataToBeUpdated && !this.isLoggedIn) {
      this.router.navigate(['/landing-page']);
     }
  }

  private getRelatedProfiles() {
    if (this.appointmentStepperService.getUsers()) {
      this.users = this.appointmentStepperService.getUsers();
    } else {
      const activeUser: UserAccountDTO = JSON.parse(localStorage.getItem('userData')!);
      this.http
        .getUsers(activeUser)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: UsersAccountDTO) => {
          if (res) {
            this.users = res;
            this.appointmentStepperService.setUsers(res);
          }
        });
    }
    this.dataService.setChangeNavbar(false);
  }

  getInitials(fullName: string){
    if(!fullName) return '';
    return fullName
      .split(' ')
      .map(part => part.charAt(0).toUpperCase())
      .join('');
  }

  showNotifications(): void {
    const modalRef: NzModalRef<NotificationsComponent> = this.modal.create({
      nzContent: NotificationsComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: {},
      },
    });
    modalRef.afterClose.subscribe((result): void => {
      this.updateNotificationCount();
    });
  }

  updateNotificationCount(): void {
    const userData = JSON.parse(this.storageService.getItem('userData')!) as UserAccountDTO;
    const individualId = userData.individualId;
    this.http.notificationUserNewcount(individualId).subscribe((response) => {
      this.notificationCount = response;
    });
  }

  protected onLanguageChange(lang: string): void {
    this.selectedLang = lang;
    this.translateService.use(lang);
    const locale = lang === 'en' ? en_US : it_IT;
    this.i18n.setLocale(locale);
    document.querySelector('html')?.setAttribute('lang', lang);
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  onLogout() {
    const textsModal = this.translateService.instant('logoutModal');
    this.modal.create({
      nzContent: ModalWithTwoButtonsComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: {
          colorActionButton: 'red',
          texts: {
            ...textsModal,
            first_button_pointer: 'exit',
          },
          actionButton: () => this.handleActionLogout(),
        },
      },
    });
  }

  handleActionLogout() {
    this.gtmService.pushLogoutEvent();
    this.authService.logout();
    this.keycloakService.clearToken();
    this.router.navigate(['login']);
    this.modal.closeAll();
  }

  ngOnDestroy(): void {
    this.subscription.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    AppComponent.onNotification.unsubscribe(); 
  }

  public changeUser(user: any): void {
    this.http
      .getAccountdDataNoConnectionValidations(user?.individualId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((accountData: AccountDataDTO) => {
        this.dataService.setAccountData(accountData);
        this.dataService.setAccountDataFrom(true);
        this.secondUser = accountData;
        const userData = JSON.parse(this.storageService.getItem('userData')!) as UserAccountDTO;
        this.storageService.setItem('oldUserData', userData);
        var data = { ...accountData.customer };
        data.functions = user.isAdult ? accountData.functions : userData.functions;
        this.storageService.setItem('userData', data);
        this.router.navigate(['/personal-area/your-data']);
      });
  }

  redirect() {
    this.router.navigate(['/personal-area/profile-management'], {
      queryParams: { value: 'new' },
    });
  }

  goToLogin(){
    this.router.navigate(['/login']);
  }
}
